export default __webpack_public_path__ + "static/media/corazon-rojo.1966e5f3.png";